export abstract class Validator {
  protected validate() {
    return {
      string: function (value: unknown): string {
        if (typeof value !== 'string') return '';
        return value;
      },
      currency: function (value: unknown): string {
        const usAmountRegex = RegExp(/((US?\$) (\d{0,3})((,\d{3})+)?(\.(\d{2})))/);
        const amountRegex = RegExp(/([A-Z]{1,2}\$) (\d{0,3})((\.\d{3})+)?(,(\d{2}))/);

        if (typeof value !== 'string') return '';
        else if ((usAmountRegex.test(value) || amountRegex.test(value)) === false)
          return '';

        return value;
      },
      date(value: unknown): Date | null {
        if (!(value instanceof Date)) return null;
        return value;
      },
    };
  }
}
